import { Icon } from "@iconify/react/dist/iconify.js";
import { FormControl, TextField } from "@mui/material";
import React from "react";
import CustomTextField from "../Form/CustomTextField";

const SearchBar = ({ value, setValue, width = "100%", paddingTop, module }) => {
    return (
        <React.Fragment>
            <CustomTextField
                values={value}
                onChange={setValue}
                placeholder={`Search by ${module || ""}`}
                padding={"2px 5px"}
                paddingTop={paddingTop}
                width={width}
                marginTop={"0px"}
                textFieldStyle={{ borderRadius: 15 }}
                InputProps={{ startAdornment: <Icon icon="ri-search-2-line" color="#7D7D7D" className="text-muted mx-1" width="20" height="20"></Icon>, }}
            />
        </React.Fragment>
    );
};

export default SearchBar;
